<template>
    <div class="row">
        <div class="col-12">
            <ibox :title="'Przymierzalnia'">
                <template slot="tools">
                    <router-link :to="`/przymierzalnia/${$route.params.env}/parametryTypy/dodaj`" class="btn btn-primary btn-xs">
                        Dodaj typ
                        <i class="fas fa-plus"></i>
                    </router-link>
                </template>
                <template slot="content" slot-scope="{ setLoading }">
                    <data-tables
                        :url="`vnfr/${$route.params.env}/parameters-types/list`"
                        :columns_list="columns_list"
                        @loading="setLoading"
                    />
                </template>
            </ibox>
        </div>
    </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import DataTables from '@/components/DataTables'

export default {
    name: 'ParameterTypes',
    components: {
        Ibox,
        DataTables
    },
    data() {
        return {
            excel: true,
            columns_list: [
                {
                    key: 'id',
                    name: this.$t( 'edit' ),
                    filter: 'btn',
                    btn: a => `<a href="#/przymierzalnia/${this.$route.params.env}/parametryTypy/${a}"><i class="fa fa-edit"></i></a>`
                },
                {
                    key: 'type_name',
                    name: 'Nazwa typu',
                    type: 'text',
                    sortable: true
                },
                                {
                    key: 'visible',
                    name: 'Widoczność',
                    type: 'text',
                    filter: 'boolean',
                    sortable: true
                }
            ]
        }
    }
}
</script>
